import styled from "styled-components";
import { mediaMax } from "components/designV2/breakpoints";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const DayShiftsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const LoadMoreSentinel = styled.div`
  height: 1px;
`;

export const LoadMoreError = styled.div`
  ${TypographyV2.b2};
  align-items: center;
  color: ${ColorV2.Blue4};
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

export const TeamFilters = styled.div`
  background: ${ColorV2.White};
  border-radius: 16px;
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 8px;
`;

export const TeamFilter = styled.button<{ $isSelected: boolean }>`
  ${TypographyV2.b2};
  background: ${(props) => (props.$isSelected ? ColorV2.Blue1 : ColorV2.Blue7)};
  border: 0;
  border-radius: 10px;
  color: ${(props) => (props.$isSelected ? ColorV2.White : ColorV2.Blue1)};
  cursor: pointer;
  flex: 0 0 auto;
  padding: 9px 12px;

  &:focus-visible {
    outline: 2px solid ${ColorV2.Blue2};
    outline-offset: 2px;
  }
`;

export const TeamSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TeamHeading = styled.h3`
  ${TypographyV2.h5};
  color: ${ColorV2.Blue1};
  margin: 0 0 10px;
`;

export const TeamShiftCount = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
  margin-left: 12px;
`;

export const ShiftCard = styled.div`
  align-items: center;
  background: ${ColorV2.White};
  border-radius: 18px;
  box-sizing: border-box;
  display: grid;
  gap: 14px;
  grid-template-columns: 150px 32px minmax(0, 1fr);
  min-height: 60px;
  padding: 10px 18px;

  ${mediaMax.mobile} {
    gap: 8px;
    grid-template-columns: 110px 32px minmax(0, 1fr);
    padding: 10px 12px;
  }
`;

export const ShiftTime = styled.div`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
  white-space: nowrap;
`;

export const ShiftAvatar = styled.div`
  align-items: center;
  background: ${ColorV2.Blue6};
  border-radius: 50%;
  display: flex;
  height: 28px;
  justify-content: center;
  overflow: hidden;
  width: 28px;
`;

export const PublicShiftAvatar = styled(ShiftAvatar)`
  background: ${ColorV2.NegativeRedLight};
`;

export const ShiftAvatarImage = styled.img`
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

export const ShiftDetails = styled.div`
  min-width: 0;
`;

export const ShiftName = styled.div`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PublicShiftName = styled(ShiftName)`
  color: ${ColorV2.NegativeRed};
`;

export const ShiftRole = styled.div`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EmptyState = styled.div`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  padding: 32px 0;
`;
